// https://vuex.vuejs.org/en/mutations.html
// import { set } from '@/utils/vuex'

export default {
  setUser(state, payload) {
    state.user = payload;
  },
  showArchiveDialog(state, payload) {
    state.archive.type = payload.type;
    state.archive.description = payload.description;
    state.archive.reference = payload.reference;
    state.archive.show = true;
  },
  closeArchiveDialog(state) {
    state.archive.show = false;
    state.archive.type = null;
    state.archive.description = "";
    state.archive.reference = null;
  },
  resetUser(state) {
    (state.auth.username = ""),
      (state.auth.token = ""),
      (state.auth.authenticated = false);
  }, 

};
